export default {
  data() {
    return {
      pointsChangeCb: null
    }
  },
  methods: {
		pointsChange(data, cb, changePoints) {
      if(!changePoints) {
        typeof cb === 'function' && cb();
        return;
      }
      this.pointsChangeCb = cb;
      const { news_id, keyword } = data;
      const { is_login, account_id, session_id } = window.sessionStorage;
      /* 如果已经登陆不做登陆值获取 */
      if(is_login != '1') {
        CP.get_client_info((info) => {
          const reg = new RegExp(keyword, 'i');
          /* 判断是否正确端 */
          if (!reg.test(info.client_code)) {
            typeof this.pointsChangeCb === 'function' && this.pointsChangeCb();
            return;
          }
          /* 非认证移动端 */
          if (/wx/i.test(info.client_code)) {
            this.loginAjax({news_id}, data);
          } else if (!/web/.test(info.client_code)) {
            if(account_id && session_id) {
              this.loginAjax({
                news_id,
                account_id,
                session_id,
              }, data);
            } else {
              /* 登陆校验 */
              CP.is_login(lo => {
                const login = lo.is_login;
                if(login == 1) {
                  CP.get_account_id(ac => {
                    CP.get_unique_id(un => {
                      const account_id = ac.account_id || '';
                      const session_id = un.unique_id || '';
                      window.sessionStorage.account_id = account_id;
                      window.sessionStorage.session_id = session_id;
                      window.sessionStorage.is_login = 1;
                      this.loginAjax({
                        news_id,
                        account_id,
                        session_id,
                      }, data);
                    })
                  })
                } else {
                  CP.show_login(sh => {
                    const login = sh.is_login;
                    if(login == 0) {
                      this.$dialog.alert({
                        title: '提示',
                        message: '请先登陆',
                        showCancelButton: true,
                        confirmButtonText: '登陆',
                      })
                        .then((res) => {
                            if(res === 'confirm') {
                              this.pointsChange(data, this.pointsChange, true);
                            }
                        })
                    } else {
                      const account_id = sh.account_id || '';
                      const session_id = sh.unique_id || '';
                      window.sessionStorage.account_id = account_id;
                      window.sessionStorage.session_id = session_id;
                      window.sessionStorage.is_login = 1;
                      this.loginAjax({
                        news_id,
                        account_id,
                        session_id,
                      }, data);
                    }
                  })
                }
              })
            }
          }
        });
      } else {
        typeof this.pointsChangeCb === 'function' && this.pointsChangeCb();
        this.pointChangeAjax(data);
      }
		},
		loginAjax(p, data) {
      this.$http.get('/activity/api.php', {
          params: {
            subm: 'news',
            m:'front',
            action:'init',
            ...p
          },
          emulateJSON: true
        }
      )
        .then(res => res.json())
        .then(res => {
          window.sessionStorage.is_login = (res.code === 5008 || res.code === 3001) ? 1 : 0;
          if(res.code === 5008 && res.data.url) {
            window.location.href = res.data.url;
          } else if(res.code === 5001 && false) {
            /* 关注弹框（未完成） */
            this.$alert('<strong>这是 <i>HTML</i> 片段</strong>', 'HTML 片段', {
              dangerouslyUseHTMLString: true
            });
          } else if(res.code !== 5001){
            this.pointChangeAjax(data);
            typeof this.pointsChangeCb === 'function' && this.pointsChangeCb();
          }
        })
		},
    pointChangeAjax(data) {
      const { news_id, article_id} = data;
      const p = {};
      news_id && (p.news_id = news_id);
      article_id && (p.article_id = article_id);
      this.$http.get('/activity/api.php', {
          params: {
            subm: 'news',
            m:'front',
            action: 'points',
            ...p
          },
          emulateJSON: true
        }
      )
        .then(res => res.json())
        .then(res => {
          /* 用户认证失效 */
          if(res.code === 4007) {
            window.sessionStorage.is_login = 0;
            this.pointsChange(data, this.pointsChangeCb, true);
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js